module.exports = __webpack_public_path__ + "img/video-bg.ff525078.jpg";